import { useEffect, useState } from "react";

export function useMobileHeaderPeep() {
  const [hasHeaderPeeped, setHasHeaderPeeped] = useState(false);

  useEffect(() => {
    const handleHeaderPeepUpdated = (e: Event) => {
      const {
        detail: { peeped = false },
      } = e as CustomEvent;
      setHasHeaderPeeped(peeped);
    };

    window.addEventListener(
      "jl-events.browser.mobileHeaderPeepUpdated",
      handleHeaderPeepUpdated,
    );

    return () =>
      window.removeEventListener(
        "jl-events.browser.mobileHeaderPeepUpdated",
        handleHeaderPeepUpdated,
      );
  }, []);

  return hasHeaderPeeped;
}
